var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlButlerFilled = function SvgHtlButlerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.453 14.997a.5.5 0 0 1-.5-.5V11.79c.011-.665.27-1.301.725-1.786a2.956 2.956 0 0 1 2.188-.787h4.192a2.95 2.95 0 0 1 2.242.816c.436.484.669 1.117.652 1.768v2.7a.5.5 0 0 1-.5.5l-8.999-.004Zm3.5-3a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0-.5.5Zm-2.1-6.683c0-.328.054-.653.162-.963a.992.992 0 0 1-.066-.356V1.997a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2c0 .121-.022.241-.065.354.108.31.162.637.162.965a3.1 3.1 0 0 1-6.194 0l.001-.002Zm1 0a2.1 2.1 0 0 0 4.194 0 1.93 1.93 0 0 0-.027-.322H5.88a1.922 1.922 0 0 0-.024.325l-.003-.003Z"
  })));
};
export default SvgHtlButlerFilled;